import { render, staticRenderFns } from "./CategoryAttributesPage.vue?vue&type=template&id=61c95e8e&scoped=true"
import script from "./CategoryAttributesPage.vue?vue&type=script&lang=js"
export * from "./CategoryAttributesPage.vue?vue&type=script&lang=js"
import style0 from "./CategoryAttributesPage.vue?vue&type=style&index=0&id=61c95e8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c95e8e",
  null
  
)

export default component.exports